import { useAuthenticationStore } from '@/stores/AuthenticationStore'
import axios from 'axios'

if (window.location.hostname.indexOf('localhost') !== -1) {

    if (navigator.appVersion.indexOf('Win') != -1) {
        axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + '/lightphone/api/'
    } else if (navigator.appVersion.indexOf('Mac') != -1) {
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    } else if (navigator.appVersion.indexOf('Linux') != -1) {
        // After connecting rpi, the windows laptop also goes here.
        // axios.defaults.baseURL = window.location.protocol + '//' + window.location.hostname + ':3111/api/'
        axios.defaults.baseURL = window.location.protocol + '//lightphone.dev.com/api/'

    }

} else {
    axios.defaults.baseURL = window.location.protocol + '//' + window.location.host + '/api/'
}

export default {

    methods: {

        /**
         * Ideally, I wanted to use the following code in the before hook of the vue router.
         * The problem is pinia, isn't available at that time.
         * There are not so nice ways to still do it, but for now rather, I will keep it simple by using the following method.
         */
        requiresAuthentication () {

            const authenticationStore = useAuthenticationStore()

            if ( ! authenticationStore.isUserAuthenticated()) {
                this.$router.push({ name: 'Login' })
            }

        },

        logout () {
            let self = this
            const authenticationStore = useAuthenticationStore()
            authenticationStore.logout()
            self.$router.push({ name: 'Login' })
        },

        async authenticationValidate(clientName, password) {

            let self = this
            
            let params = {
                clientName: clientName,
                password: password
            }

            return await axios.get('validate_password.php', {
                params
            }).then((response) => {
                return response.data
            }).catch((error) => {
                // TODO: Log error
                console.log(error)
                return false
            })
        }

    }
}
